import useTestBuilder from "../Utils/testbuilder/useTestBuilder";
import TestBuilderLayout from "../Utils/testbuilder/TestBuilderLayout";
import { url } from "../../Config";

const TestEditor = ({ initialData, slug, user, navigate }) => {
  const builder = useTestBuilder(initialData);

  const updateTest = async () => {
    const response = await fetch(`${url}/api/edit-test/${slug}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
      body: JSON.stringify({
        testName: builder.testName,
        testDescription: builder.testDescription,
        testInstructions: builder.testInstructions,
        testTimeLimit: builder.testTimeLimit,
        questions: builder.questions,
        gradeRules: builder.gradeRules,
        private: builder.isPrivate,
        modifications: builder.modifications,
      }),
    });

    if (response.ok) {
      alert("Updated!");
      navigate(-1);
    }
  };

  return (
    <TestBuilderLayout
      builder={builder}
      onSubmit={updateTest}
      mode="edit"
    />
  );
};

export default TestEditor;
